import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  #triggerOfferCheck = () => {
    if (typeof window.kaidoMaybeOfferMembership !== 'function') {
      return;
    }
    window.kaidoMaybeOfferMembership();
    setTimeout(() => window.kaidoMaybeOfferMembership(), 250);
    setTimeout(() => window.kaidoMaybeOfferMembership(), 650);
    setTimeout(() => window.kaidoMaybeOfferMembership(), 1200);
    if (typeof window.kaidoStartOfferPoll === 'function') {
      window.kaidoStartOfferPoll();
    }
  };

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    const blockedAt = window.__KAIDO_BLOCKED_ADD_AT;
    if (blockedAt && Date.now() - blockedAt < 1500) {
      return;
    }

    if (this.hasAttribute('auto-open')) {
      this.showDialog();
      this.#triggerOfferCheck();
    }
  };

  open() {
    this.showDialog();
    this.#triggerOfferCheck();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
